import loglevel from "loglevel";
import { MouseEvent, useCallback } from "react";
import { useNavigate } from "react-router";
import { ClickableElementLinkInfo } from "shared/components/clickable/ClickableElementLinkInfo";
import { isValidUrl } from "shared/utils/UrlUtils";

const log = loglevel.getLogger("DataTableLinkHandler");

export const useClickableElementOnClickHandler = () => {
  const navigate = useNavigate();
  return useCallback(
    (
      linkInfo: ClickableElementLinkInfo,
      pointerEvent: MouseEvent | undefined,
    ) => {
      if (pointerEvent?.defaultPrevented) {
        return;
      }
      if (linkInfo.type === "generic") {
        if (isValidUrl(linkInfo.to)) {
          const forceNewTab =
            pointerEvent?.metaKey ||
            pointerEvent?.ctrlKey ||
            pointerEvent?.shiftKey ||
            pointerEvent?.altKey;
          window.open(
            linkInfo.to,
            forceNewTab || !linkInfo.target ? "_blank" : linkInfo.target,
          );
        } else {
          navigate(linkInfo.to);
        }
      } else if (linkInfo.type === "onclick") {
        linkInfo.onClick();
      } else {
        log.warn(`Unhandled link type: ${linkInfo.type}`);
      }
    },
    [navigate],
  );
};
